import {LatLngExpression, PointExpression} from 'leaflet';
import React, {MutableRefObject, ReactNode} from 'react';
import {Popup} from 'react-leaflet';
import {PopupFeatures} from "@ui/leafletCustom/types/popup";

interface IProps {
    children: ReactNode,
    position?: LatLngExpression;
    maxWidth?: number | undefined;
    minWidth?: number | undefined;
    maxHeight?: number | undefined;
    keepInView?: boolean | undefined;
    closeButton?: boolean | undefined;
    autoPan?: boolean | undefined;
    autoPanPaddingTopLeft?: PointExpression | undefined;
    autoPanPaddingBottomRight?: PointExpression | undefined;
    autoPanPadding?: PointExpression | undefined;
    autoClose?: boolean | undefined;
    closeOnClick?: boolean | undefined;
    closeOnEscapeKey?: boolean | undefined;
    popupFeaturesRef?: MutableRefObject<PopupFeatures>
}

// TODO close other popup

const LeafletPopup = ({
                          children,
                          position,
                          maxWidth,
                          minWidth,
                          maxHeight,
                          keepInView,
                          closeButton = true,
                          autoPan,
                          autoPanPaddingTopLeft,
                          autoPanPaddingBottomRight,
                          autoPanPadding,
                          autoClose,
                          closeOnClick,
                          closeOnEscapeKey,
                          popupFeaturesRef,
                      }: IProps) => {
    return (
        <Popup
            position={position}
            maxWidth={maxWidth}
            minWidth={minWidth}
            maxHeight={maxHeight}
            keepInView={keepInView}
            closeButton={closeButton}
            autoPan={autoPan}
            autoPanPaddingTopLeft={autoPanPaddingTopLeft}
            autoPanPaddingBottomRight={autoPanPaddingBottomRight}
            autoPanPadding={autoPanPadding}
            autoClose={autoClose}
            closeOnClick={closeOnClick}
            closeOnEscapeKey={closeOnEscapeKey}
            ref={popupFeaturesRef}
        >
            {children}
        </Popup>
    );
};

export default Popup;